import { useState } from "react";
import { currentTheme, setTheme, type Theme } from "../theme";

/**
 * Light and dark are the same object under a different glaze. In the app the theme lives in
 * Preferences; this toggle now only appears on the logged-out landing (which can't reach an in-app
 * page) — as `iconOnly` there, a sun/moon glyph, so the "glaze" text isn't scattered about.
 */
export function ThemeToggle({ iconOnly = false }: { iconOnly?: boolean } = {}) {
  const [theme, setLocal] = useState<Theme>(currentTheme());
  const next: Theme = theme === "dark" ? "light" : "dark";
  const label = `Switch to the ${next} glaze`;

  return (
    <button
      className="quiet-btn"
      onClick={() => {
        setTheme(next);
        setLocal(next);
      }}
      aria-label={label}
      title={iconOnly ? label : undefined}
    >
      {iconOnly ? (next === "dark" ? "☾" : "☀") : next === "dark" ? "Dark glaze" : "Light glaze"}
    </button>
  );
}
